'use client';

var translations = {
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    Undo: 'Hoàn tác',
    'Accept invitation': 'Chấp nhận lời mời',
    'Invited by employer': 'Được mời ứng tuyển'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
